import CausedError from "./CausedError.js";
class NotImplementedError extends CausedError {
  constructor(message = 'Not Implemented', options) {
    super(message, options);
  }
}
export default NotImplementedError;